import BaseLevelScene from "src/app/Scenes/BaseLevelScene";
import MainScene from "src/app/Scenes/MainScene";
import { WebsocketService } from "src/app/services/websocket.service";
import { PlayerMetadata } from "./PlayerMetadata";

export class Structure extends Phaser.Physics.Matter.Sprite{
    name = "house";
    x: number = 0;
    y: number = 0;
    imageWidth: number = 0;
    imageHeight: number = 0;
    scene: MainScene;
    internalSceneName: string;

    constructor(scene: MainScene, x: number, y: number, externalImage: string, internalSceneName: string){
        super(scene.matter.world, x, y, externalImage);

        this.scene = scene;
        this.x = x;
        this.y = y;
        this.imageWidth = this.texture.source[0].width;
        this.imageHeight = this.texture.source[0].height;
        this.internalSceneName = internalSceneName;

        // Create sensors for entering/exiting
        const Bodies = new Phaser.Physics.Matter.MatterPhysics(scene).bodies;
        const rectA = Bodies.rectangle(this.x + this.imageWidth/2, this.y - this.imageHeight/4, this.imageWidth, this.imageHeight/2, {isSensor: true});
        const rectB = Bodies.rectangle(this.x + this.imageWidth/2, this.y + this.imageHeight/4, this.imageWidth, this.imageHeight/2, {isSensor: false, label: 'houseCollider'});
        const rectC = Bodies.rectangle(this.x + this.imageWidth/2, this.y - this.imageHeight/2, 24, 24, {isSensor: true});
        const rectD = Bodies.rectangle(this.x + this.imageWidth/2, this.y + this.imageHeight/2, 24, 24, {isSensor: true, label: 'houseSensor'});

        // Combine into a compound body set on the portal
        const Body = new Phaser.Physics.Matter.MatterPhysics(scene).body;
        const compoundBody = Body.create({
            parts: [ rectA, rectB, rectC, rectD]
        });

        this.setExistingBody(compoundBody);
        this.setStatic(true);
        this.scene.add.existing(this);
        this.setDepth(2);  
    }

    static preload(scene: Phaser.Scene){
        scene.load.image('house', 'assets/portals/house1.png');
        scene.load.image('mausoleum', 'assets/portals/Mausoleum.png');
    }

    enter() {
        console.log(`Entering: structure`);
        BaseLevelScene.previousSceneKey = this.scene.scene.key;
        this.scene.scene.switch(this.internalSceneName).scene;
        
        const newScene = this.scene.scene.get(this.internalSceneName);
        WebsocketService.setScene(newScene as MainScene | BaseLevelScene);
        if(WebsocketService.socket && WebsocketService.socket.readyState === WebSocket.OPEN){

            // Update the players level globally.
            MainScene.playerMetadata.levelName = this.scene.scene.key;
            MainScene.playerMetadata.lastUpdated = Date.now();
            WebsocketService.updatePlayer(MainScene.playerMetadata as PlayerMetadata);
        }
        this.scene.scene.get(this.internalSceneName).cameras.main.fadeIn(1000, 0, 0, 0);
    }
}